import gbFlag from 'flag-icons/flags/1x1/gb.svg';
import rsFlag from 'flag-icons/flags/1x1/rs.svg';
import esFlag from 'flag-icons/flags/1x1/es.svg';
import seFlag from 'flag-icons/flags/1x1/se.svg';

export type LanguageCode = 'en' | 'sr' | 'es' | 'sv';

export type LanguageOption = {
  /** i18next language code — must be a real language tag, since plural rules come from Intl.PluralRules(code) */
  code: LanguageCode;
  /** BCP 47 tag for <html lang> and Intl formatting */
  locale: string;
  /** Native name, shown in the picker */
  name: string;
  /** Short label for the navbar toggle */
  short: string;
  flag: string;
};

export const LANGUAGES: LanguageOption[] = [
  { code: 'en', locale: 'en-GB', name: 'English', short: 'ENG', flag: gbFlag },
  { code: 'sr', locale: 'sr-Latn', name: 'Srpski', short: 'SRB', flag: rsFlag },
  { code: 'es', locale: 'es', name: 'Español', short: 'ESP', flag: esFlag },
  { code: 'sv', locale: 'sv', name: 'Svenska', short: 'SWE', flag: seFlag },
];

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export const getLanguage = (code?: string): LanguageOption =>
  LANGUAGES.find((l) => l.code === code) || LANGUAGES.find((l) => l.code === DEFAULT_LANGUAGE)!;
